module.exports = __webpack_public_path__ + "static/media/p-content-4.e16424ed.png";